import React from 'react';
import { Features } from './components/Features';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="ventosas-page min-h-screen bg-cream font-sans text-brand-900 selection:bg-brand-500 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Features data-id="element-3" />
      <Pricing data-id="element-4" />
    </div>;
}